import { render, staticRenderFns } from "./BuySubscription.vue?vue&type=template&id=116920f0&scoped=true&"
import script from "./BuySubscription.vue?vue&type=script&lang=js&"
export * from "./BuySubscription.vue?vue&type=script&lang=js&"
import style0 from "./BuySubscription.vue?vue&type=style&index=0&id=116920f0&lang=scss&scoped=true&"
import style1 from "./BuySubscription.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116920f0",
  null
  
)

export default component.exports